import { UserRole } from '../types/user.types';

/**
 * Roles allowed on /marketing/email/analytics. Shared by the route guard in
 * App.tsx and the post-create redirect, so the two can't drift apart.
 */
export const EMAIL_ANALYTICS_ROLES: UserRole[] = [
  UserRole.PROPCLOUDAI_SUPER_USER,
  UserRole.HQ_MANAGER,
];

/**
 * Where to land after creating an email campaign. Analytics for roles that may
 * open it; everyone else (HQ admin, advertising roles) goes to the campaign
 * list instead of a bare /unauthorized page.
 */
export function emailCampaignCreatedPath(role: UserRole | undefined, campaignId: string): string {
  return role && EMAIL_ANALYTICS_ROLES.includes(role)
    ? `/marketing/email/analytics?campaign=${campaignId}`
    : '/marketing/email/campaigns';
}
